export const UserGroupMap = {
  vendor: 'manageVendors',
  broker: 'manageBrokers',
};
